import componentIterator from './utils/componentIterator';
import '../patterns/02-ui-components/02-navigation-bar/navigation-bar';
import '../patterns/02-ui-components/04-hero/hero';
import '../patterns/02-ui-components/07-products/products';
import '../patterns/02-ui-components/08-gallery/gallery';
import '../patterns/02-ui-components/10-tiles/tiles';
import '../patterns/02-ui-components/11-story-image/story-image';
import '../patterns/02-ui-components/13-story-video/story-video';
import '../patterns/02-ui-components/18-top-of-page/top-of-page';
import '../patterns/02-ui-components/19-quick-links/quick-links';
import '../patterns/02-ui-components/21-ambassadors/ambassadors';
import '../patterns/02-ui-components/23-static-prospect-box/static-prospect-box';
import '../patterns/02-ui-components/24-floating-prospect-box/floating-prospect-box';
import '../patterns/02-ui-components/25-stories/stories';
import '../patterns/02-ui-components/28-filters/filters';
import '../patterns/02-ui-components/30-latest-events/latest-events';
import '../patterns/02-ui-components/32-static-filters/static-filters';
import '../patterns/02-ui-components/37-alpha-academy-video-training/alpha-academy-video-training';
import '../patterns/02-ui-components/39-alpha-academy-video-modal/alpha-academy-video-modal';
import '../patterns/_04-reusable-components/01-responsive-image/responsive-image';
import '../patterns/_04-reusable-components/04-content-more/content-more';

componentIterator();
